import React from "react";
import {FormatAs} from "../../DynamicFormTypes.ts";
import {StaticFieldDisplayProps} from "./staticFieldUtils.ts";
import {StaticCurrencyDisplay} from "./display/StaticCurrencyDisplay.tsx";
import {StaticPercentDisplay} from "./display/StaticPercentageDisplay.tsx";
import {StaticLinkDisplay} from "./display/StaticLinkDisplay.tsx";
import {StaticModalDisplay} from "./display/StaticModalDisplay.tsx";
import {StaticComponentDisplay} from "./display/StaticComponentDisplay.tsx";
import {StaticDate} from "./display/StaticDate.tsx";
import {StaticSelectDescription} from "./display/StaticSelectDescription.tsx";
import {StaticSpacer} from "./display/StaticSpacer.tsx";
import {StaticLabel} from "./display/StaticLabel.tsx";
import {StaticCheckbox} from "./display/StaticCheckbox.tsx";
import {StaticImage} from "./display/StaticImage.tsx";
import {StaticRepairImages} from "./display/StaticRepairImages.tsx";
import {StaticDefaultDisplay} from "./display/StaticDefaultDisplay.tsx";

const StaticDisplayRenderer: React.FC<StaticFieldDisplayProps> = ({value, component, controller}) => {
    const formatAs = component.formatAs ?? FormatAs.NONE;
    let displayValue = value ?? component.placeHolder;

    switch (formatAs) {
        case FormatAs.CURRENCY:
            return <StaticCurrencyDisplay value={displayValue} component={component} controller={controller} />;

        case FormatAs.PERCENTAGE:
            return <StaticPercentDisplay value={displayValue} component={component} controller={controller}/>;

        case FormatAs.LINK:
            return <StaticLinkDisplay value={displayValue} component={component} controller={controller} />;

        case FormatAs.MODAL:
            return <StaticModalDisplay value={displayValue} component={component} controller={controller} />;

        case FormatAs.COMPONENT:
            return <StaticComponentDisplay value={displayValue} component={component} controller={controller}/>;

        case FormatAs.DATE:
            return <StaticDate value={displayValue} component={component} controller={controller}/>;

        case FormatAs.SELECT_DESCRIPTION:
            return <StaticSelectDescription value={displayValue} component={component} controller={controller}/>;

        case FormatAs.SPACER:
            return <StaticSpacer value={displayValue} component={component} controller={controller}/>;

        case FormatAs.LABEL:
            return <StaticLabel value={displayValue} component={component} controller={controller} />;

        case FormatAs.CHECKBOX:
            return <StaticCheckbox value={displayValue} component={component} controller={controller}/>;

        case FormatAs.IMAGE:
            return <StaticImage value={displayValue} component={component} controller={controller}/>;

        case FormatAs.REPAIR_IMAGES:
            return <StaticRepairImages value={displayValue} component={component} controller={controller}/>;

        case FormatAs.NONE:
        default:
            return <StaticDefaultDisplay value={displayValue} component={component} controller={controller}/>;
    }
};
export const StaticDisplay = React.memo(StaticDisplayRenderer);